<template>
  <div>
    <section class="header-sec">
      <div class="container">
        <div class="headerlogo">
          <img src="/images/logo.png" alt="Logo">
        </div>
        <div class="headermock">
          <div class="mockhead-hamburger">
            <!-- Hamburger Icon -->
            <div class="header-icon-wrapper">
              <div class="hamburger-icon" @click.stop="toggleMainDropdown">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" fill="currentColor" />
                </svg><span v-if="bubbles == 1">Menu</span>
              </div>
            </div>
            <!-- Main Dropdown -->
            <ul class="main-dropdown" v-show="isMainDropdownOpen" @click.stop>
              <li><router-link to="/userlogin"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.38 16.2904H4.38C2.94 16.2904 1.75999 15.1904 1.75999 13.8504V9.15039C1.75999 8.87039 2 8.65039 2.3 8.65039C2.6 8.65039 2.84 8.87039 2.84 9.15039V13.8504C2.84 14.6504 3.53 15.2904 4.38 15.2904H11.38C12.23 15.2904 12.93 14.6404 12.93 13.8504V9.15039C12.93 8.87039 13.17 8.65039 13.47 8.65039C13.77 8.65039 14.01 8.87039 14.01 9.15039V13.8504C14.01 15.2004 12.84 16.2904 11.39 16.2904H11.38Z" fill="#231F20"/>
                <path d="M0.649993 9.17101C0.509993 9.17101 0.380003 9.12102 0.270003 9.01102C0.0600031 8.80102 0.0600031 8.46101 0.270003 8.25101L7.50999 1.01102C7.71999 0.801016 8.06 0.801016 8.27 1.01102L15.48 8.22101C15.69 8.43101 15.69 8.77102 15.48 8.98102C15.27 9.19102 14.93 9.19102 14.72 8.98102L7.89 2.15102L1.03 9.01102C0.929998 9.11102 0.789993 9.17101 0.649993 9.17101Z" fill="#231F20"/>
                </svg>
                <span class="lispan">Home</span></router-link></li>
              <li><router-link to="/dashboard"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="6" height="6" rx="1" stroke="#231F20" stroke-width="1.2"/>
                <rect x="9" y="1" width="6" height="6" rx="1" stroke="#231F20" stroke-width="1.2"/>
                <rect x="1" y="9" width="6" height="6" rx="1" stroke="#231F20" stroke-width="1.2"/>
                <rect x="9" y="9" width="6" height="6" rx="1" stroke="#231F20" stroke-width="1.2"/>
                </svg>
                <span class="lispan">Dashboard</span></router-link></li>
              <li v-if="!hideMockHome"><router-link to="/mocksection"><svg width="19" height="16" viewBox="0 0 38 33" fill="none"
                    xmlns="http://www.w3.org/2000/svg" style="stroke:black">
                    <path
                      d="M34.8499 11.3384C35.0599 7.30839 31.98 3.80839 27.96 3.49839C25.96 1.70839 23.1099 1.11839 20.5599 1.98839C18.5599 0.578392 15.8699 0.62839 13.9199 2.11839C11.6299 0.93839 8.61993 1.83839 7.35993 4.09839C4.63993 4.06839 2.38993 6.22839 2.29993 8.95839C-1.93007 12.6284 1.70992 22.2084 7.59992 21.6184C8.67992 25.4184 13.5699 27.2484 16.8599 25.0584C17.2999 26.7884 18.9499 27.0684 20.3599 27.4684L23.9899 31.6184C26.9799 33.8484 27.6699 30.0984 27.3499 27.8284C32.0199 28.4184 36.61 24.7084 35.26 20.4484C39.04 18.6784 38.7699 12.7684 34.8499 11.3484V11.3384ZM26.0999 30.3384C26.0999 30.5184 26.03 30.6884 25.9 30.8084C25.77 30.9284 25.5999 30.9984 25.4199 30.9984C25.2299 30.9984 25.0499 30.9184 24.9199 30.7784L21.2999 26.6284C20.9299 26.2084 20.39 25.9784 19.83 25.9884C18.82 25.9884 17.99 25.1784 17.96 24.1684C18.23 23.9084 18.4799 23.6184 18.6899 23.3184C18.7199 23.3284 18.74 23.3384 18.77 23.3484C18.83 23.3784 18.9 23.4084 18.96 23.4384C18.98 23.4384 19.01 23.4484 19.03 23.4484C19.85 23.7784 20.71 23.9884 21.59 24.0684C22.51 25.8384 24.1499 27.1184 26.0999 27.5684V30.3284V30.3384ZM28.2899 26.6184C27.7999 26.6184 27.3199 26.5684 26.8499 26.4684C25.3099 26.2084 23.94 25.3484 23.03 24.0784C25.85 23.8484 28.38 22.2784 29.84 19.8684C31.02 20.8284 32.59 21.1984 34.08 20.8584C34.18 21.1984 34.2399 21.5584 34.2399 21.9184C34.2399 24.5084 31.5699 26.6184 28.2899 26.6184ZM32.9899 19.7284C31.3299 19.7184 29.87 18.6284 29.39 17.0484C29.29 16.7184 28.9399 16.5284 28.6099 16.6284C28.2799 16.7284 28.0899 17.0684 28.1899 17.3984C28.3599 17.9384 28.61 18.4484 28.95 18.9084C27.88 20.8884 25.98 22.2784 23.78 22.7084C21.57 23.1384 19.2899 22.5584 17.5599 21.1184C17.2899 20.8984 16.8999 20.9384 16.6799 21.1984C16.4599 21.4684 16.5 21.8584 16.76 22.0784C17.03 22.2984 17.3199 22.5084 17.6099 22.6984C16.6699 23.9684 15.18 24.7184 13.59 24.7284C13.43 24.7284 13.2799 24.7284 13.1199 24.7084C13.0299 24.7084 12.9499 24.6884 12.8599 24.6784C12.7999 24.6784 12.7399 24.6584 12.6799 24.6484C12.5599 24.6284 12.45 24.5984 12.33 24.5684H12.28C10.78 24.1484 9.54996 23.0684 8.94995 21.6284L8.92994 21.5884C8.87994 21.4684 8.83993 21.3484 8.79993 21.2284C8.79993 21.2084 8.78997 21.1784 8.77997 21.1584C8.73997 21.0384 8.70995 20.9184 8.68995 20.7984C8.58994 20.3384 8.54996 19.8584 8.57996 19.3884C8.80996 16.7084 11.08 14.6684 13.77 14.7184H17.33C18.37 14.7184 19.21 13.8784 19.21 12.8384C19.21 12.4884 19.49 12.2084 19.84 12.2084H21.7199C22.0699 12.2084 22.3499 11.9284 22.3499 11.5784C22.3499 11.2284 22.0699 10.9484 21.7199 10.9484H19.84C18.8 10.9484 17.96 11.7884 17.96 12.8284C17.96 13.1784 17.68 13.4584 17.34 13.4584H13.78C10.43 13.4084 7.61997 15.9684 7.33997 19.2984C7.31997 19.6484 7.32993 19.9884 7.35993 20.3384H7.31995C5.16995 20.3384 3.26996 18.9584 2.57996 16.9284C2.80996 17.0884 3.04993 17.2284 3.29993 17.3484C3.60993 17.4984 3.98995 17.3684 4.12995 17.0484C4.27995 16.7384 4.14996 16.3584 3.82996 16.2184C3.16996 15.9084 2.61993 15.4084 2.23993 14.7884C2.23993 14.7884 2.23993 14.7784 2.23993 14.7684C1.20993 13.0784 1.67994 10.8684 3.30994 9.73839C3.78994 9.39839 4.32997 9.18839 4.89997 9.10839C5.23997 9.05839 5.47994 8.73839 5.42993 8.39839C5.37993 8.05839 5.05991 7.81839 4.71991 7.86839C4.35991 7.91839 4.00993 8.00839 3.67993 8.13839C3.95993 7.04839 4.70991 6.14839 5.71991 5.66839C6.72991 5.18839 7.90993 5.18839 8.91993 5.66839C9.22993 5.80839 9.59993 5.66839 9.73993 5.36839C9.88993 5.05839 9.75996 4.69839 9.45996 4.53839C9.22997 4.42839 8.97993 4.33839 8.73993 4.26839C9.90993 2.74839 12.0399 2.35839 13.6699 3.36839C14.1099 3.63839 14.49 3.99839 14.78 4.41839C14.98 4.69839 15.36 4.75839 15.64 4.56839C15.92 4.37839 15.9899 3.98839 15.7999 3.70839C15.5799 3.38839 15.32 3.09839 15.03 2.84839C16.27 2.06839 17.83 1.97839 19.15 2.60839C19.05 2.66839 18.9499 2.71839 18.8599 2.77839C18.5699 2.96839 18.4899 3.35839 18.6799 3.64839C18.8699 3.93839 19.2599 4.01839 19.5499 3.82839C21.9699 2.29839 25.1099 2.57839 27.2199 4.50839C27.8199 5.05839 28.31 5.72839 28.65 6.46839C28.74 6.67839 28.9299 6.82839 29.1599 6.84839C29.3899 6.86839 29.6099 6.76839 29.7399 6.57839C29.8699 6.38839 29.89 6.14839 29.78 5.93839C29.63 5.61839 29.45 5.30839 29.26 5.00839C31.84 5.83839 33.5899 8.23839 33.5999 10.9484C33.5999 11.0984 33.6 11.2484 33.58 11.3984C33.58 11.4784 33.5699 11.5584 33.5599 11.6484C33.4999 12.1884 33.3699 12.7184 33.1799 13.2284C33.0999 13.4384 33.13 13.6684 33.27 13.8484C33.41 14.0184 33.6299 14.1084 33.8499 14.0784C34.0699 14.0484 34.26 13.8984 34.34 13.6884C34.47 13.3384 34.5799 12.9784 34.6599 12.6184C36.2099 13.3984 37.0299 15.1384 36.6199 16.8384C36.2199 18.5284 34.7099 19.7184 32.9699 19.7184L32.9899 19.7284Z"
                      fill="white" />
                  </svg>

                  <span class="lispan">

                    Mocks</span></router-link></li>
              <li><router-link to=""><svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.4598 0.0898438H2.70982C1.66982 0.0898438 0.819824 0.939851 0.819824 1.97985V11.8898C0.819824 12.9298 1.66982 13.7798 2.70982 13.7798H14.4598C15.4998 13.7798 16.3498 12.9298 16.3498 11.8898V1.97985C16.3498 0.939851 15.4998 0.0898438 14.4598 0.0898438ZM15.1798 12.8998L10.2898 8.92985V8.63985H11.4398L15.6798 12.0798C15.6298 12.4198 15.4398 12.7098 15.1798 12.8998ZM1.48982 12.0798L5.72981 8.63985H6.87982V8.92985L1.98982 12.8998C1.71982 12.7098 1.53982 12.4198 1.48982 12.0798ZM1.98982 0.979851L6.87982 4.94984V5.23985H5.72981L1.48982 1.79985C1.53982 1.45985 1.72982 1.16985 1.98982 0.979851ZM2.72981 0.739845H6.87982V4.09985L2.72981 0.739845ZM4.68982 5.23985H1.46982V2.62984L4.68982 5.23985ZM1.46982 8.63985H4.68982L1.46982 11.2498V8.63985ZM6.87982 9.76984V13.1298H2.72981L6.87982 9.76984ZM7.72981 13.1298V8.20985C7.72981 7.97985 7.53981 7.78985 7.30981 7.78985H1.46982V6.07985H7.30981C7.53981 6.07985 7.72981 5.88985 7.72981 5.65985V0.739845H9.43982V5.65985C9.43982 5.88985 9.62982 6.07985 9.85982 6.07985H15.6998V7.78985H9.85982C9.62982 7.78985 9.43982 7.97985 9.43982 8.20985V13.1298H7.72981ZM15.6798 1.78985L11.4398 5.22985H10.2898V4.93985L15.1798 0.969849C15.4498 1.15985 15.6298 1.44985 15.6798 1.78985ZM15.6998 2.60985V5.21985H12.4798L15.6998 2.60985ZM10.2898 4.08984V0.729851H14.4398L10.2898 4.08984ZM10.2898 9.75985L14.4398 13.1199H10.2898V9.75985ZM12.4798 8.62984H15.6998V11.2398L12.4798 8.62984Z"
                      fill="#231F20" />
                  </svg>
                  <span class="lispan">

                    About MLA</span></router-link></li>
              <li><router-link to=""><svg width="19" height="20" viewBox="0 0 19 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.2702 9.10016C15.2702 10.6702 14.6102 12.1802 13.4702 13.2502C12.9402 13.7502 12.6302 14.4502 12.6302 15.1702V17.4902C12.6302 18.3402 11.9402 19.0302 11.1002 19.0302H8.08015C7.23015 19.0302 6.55016 18.3402 6.55016 17.4902V15.1702C6.55016 14.4502 6.24016 13.7502 5.71016 13.2502C4.56016 12.1802 3.91016 10.6702 3.91016 9.10016C3.91016 5.96016 6.46016 3.41016 9.60016 3.41016C12.7402 3.41016 15.2901 5.96016 15.2901 9.10016H15.2702ZM7.35016 15.9402V17.6201C7.35016 17.9401 7.61015 18.1902 7.92015 18.1902H11.2301C11.5501 18.1902 11.8002 17.9301 11.8002 17.6201V15.9402H7.35016ZM11.8202 14.9602C11.8702 14.0902 12.2702 13.2602 12.9102 12.6602C13.9102 11.7302 14.4602 10.4602 14.4602 9.10016C14.4602 6.41016 12.2702 4.21016 9.57016 4.21016C6.87016 4.21016 4.68015 6.40016 4.68015 9.10016C4.68015 10.4602 5.23015 11.7302 6.23015 12.6602C6.87015 13.2602 7.27016 14.1002 7.32016 14.9602V15.1102H11.8102V14.9602H11.8202Z"
                      fill="#231F20" />
                    <path
                      d="M9.58018 0.00976562C9.36018 0.00976562 9.18018 0.189767 9.18018 0.409767V1.53976C9.18018 1.75976 9.36018 1.93977 9.58018 1.93977C9.80018 1.93977 9.98018 1.75976 9.98018 1.53976V0.409767C9.98018 0.189767 9.80018 0.00976562 9.58018 0.00976562Z"
                      fill="#231F20" />
                    <path
                      d="M3.44005 2.54883C3.34005 2.54883 3.23005 2.58882 3.16005 2.66882C3.09005 2.74882 3.04004 2.84882 3.04004 2.94882C3.04004 3.04882 3.08005 3.15883 3.16005 3.22883L3.96005 4.02882C4.12005 4.18882 4.37004 4.18882 4.53004 4.02882C4.61004 3.94882 4.65004 3.84883 4.65004 3.74883C4.65004 3.64883 4.61004 3.53883 4.53004 3.46883L3.73004 2.66882C3.65004 2.58882 3.55004 2.54883 3.45004 2.54883H3.44005Z"
                      fill="#231F20" />
                    <path
                      d="M0.899994 8.69922C0.679994 8.69922 0.5 8.87923 0.5 9.09923C0.5 9.31923 0.679994 9.49922 0.899994 9.49922H2.03C2.25 9.49922 2.42999 9.31923 2.42999 9.09923C2.42999 8.87923 2.25 8.69922 2.03 8.69922H0.899994Z"
                      fill="#231F20" />
                    <path
                      d="M17.1402 8.69922C16.9202 8.69922 16.7402 8.87923 16.7402 9.09923C16.7402 9.31923 16.9202 9.49922 17.1402 9.49922H18.2702C18.4902 9.49922 18.6702 9.31923 18.6702 9.09923C18.6702 8.87923 18.4902 8.69922 18.2702 8.69922H17.1402Z"
                      fill="#231F20" />
                    <path
                      d="M15.44 2.66883L14.64 3.46883C14.56 3.54883 14.52 3.64883 14.52 3.74883C14.52 3.84883 14.56 3.95883 14.64 4.02883C14.79 4.17883 15.06 4.17883 15.21 4.02883L16.01 3.22883C16.09 3.14883 16.13 3.04883 16.13 2.94883C16.13 2.84883 16.09 2.73883 16.01 2.66883C15.85 2.50883 15.6 2.50883 15.44 2.66883Z"
                      fill="#231F20" />
                    <path
                      d="M7.15977 9.33046C7.05977 9.33046 6.94978 9.37046 6.87978 9.45046C6.79978 9.53046 6.75977 9.63046 6.75977 9.73046C6.75977 9.83046 6.79978 9.94046 6.87978 10.0105L7.93977 11.0705C8.09977 11.2305 8.34977 11.2305 8.50977 11.0705L11.9098 7.67046C12.0698 7.51046 12.0698 7.26047 11.9098 7.10047C11.7498 6.94047 11.4998 6.94047 11.3398 7.10047L8.22977 10.2105L7.44977 9.43046C7.36977 9.35046 7.26977 9.31046 7.16977 9.31046L7.15977 9.33046Z"
                      fill="#231F20" />
                  </svg><span class="lispan">FAQ</span></router-link></li>
              <li><router-link to=""><svg width="15" height="19" viewBox="0 0 15 19" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.57967 9.7404C9.50198 9.7404 10.2497 8.99272 10.2497 8.0704C10.2497 7.14809 9.50198 6.40039 8.57967 6.40039C7.65735 6.40039 6.90967 7.14809 6.90967 8.0704C6.90967 8.99272 7.65735 9.7404 8.57967 9.7404Z"
                      fill="#231F20" />
                    <path
                      d="M4.96005 6.90054C5.88237 6.90054 6.63005 6.15286 6.63005 5.23055C6.63005 4.30823 5.88237 3.56055 4.96005 3.56055C4.03774 3.56055 3.29004 4.30823 3.29004 5.23055C3.29004 6.15286 4.03774 6.90054 4.96005 6.90054Z"
                      fill="#231F20" />
                    <path
                      d="M9.90974 3.8107C10.8321 3.8107 11.5797 3.06302 11.5797 2.1407C11.5797 1.21839 10.8321 0.470703 9.90974 0.470703C8.98743 0.470703 8.23975 1.21839 8.23975 2.1407C8.23975 3.06302 8.98743 3.8107 9.90974 3.8107Z"
                      fill="#231F20" />
                    <path
                      d="M14.3598 8.78117C14.3598 8.67117 14.3598 8.56117 14.3598 8.45117H11.8198C11.8198 8.56117 11.8398 8.67117 11.8398 8.78117C11.8398 11.1212 9.92981 13.0312 7.58981 13.0312C5.24981 13.0312 3.33981 11.1212 3.33981 8.78117C3.33981 8.67117 3.33982 8.56117 3.35982 8.45117H0.819824C0.819824 8.56117 0.819824 8.67117 0.819824 8.78117C0.819824 12.0812 3.18982 14.8312 6.31982 15.4312V18.8712H8.87982V15.4312C12.0098 14.8312 14.3798 12.0812 14.3798 8.78117H14.3598Z"
                      fill="#231F20" />
                  </svg>
                  <span class="lispan">

                    About us
                  </span>
                </router-link></li>
              <li class="has-nested" @click.stop="toggleNestedDropdown">
                <router-link to=""><svg width="17" height="20" viewBox="0 0 17 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.2297 19.0799H2.92969C1.81969 19.0799 0.929688 18.1799 0.929688 17.0799V16.1999C0.929688 14.0399 1.8397 11.9699 3.4397 10.5199C4.1097 9.91987 5.0997 9.82987 5.8597 10.3199C6.6497 10.8299 7.58969 11.0999 8.58969 11.0999C9.58969 11.0999 10.5297 10.8299 11.3197 10.3199C12.0797 9.82987 13.0697 9.91987 13.7397 10.5199C15.3397 11.9699 16.2497 14.0399 16.2497 16.1999V17.0799C16.2497 18.1899 15.3497 19.0799 14.2397 19.0799H14.2297ZM4.7697 10.6799C4.4497 10.6799 4.12969 10.7999 3.89969 11.0199C2.44969 12.3399 1.61969 14.2199 1.61969 16.1899V17.0699C1.61969 17.7999 2.20969 18.3799 2.92969 18.3799H14.2297C14.9597 18.3799 15.5397 17.7899 15.5397 17.0699V16.1899C15.5397 14.2199 14.7097 12.3499 13.2597 11.0199C12.8197 10.6299 12.1797 10.5699 11.6797 10.8899C10.7797 11.4699 9.6997 11.7799 8.5697 11.7799C7.4397 11.7799 6.3697 11.4699 5.4597 10.8899C5.2597 10.7599 5.00969 10.6799 4.75969 10.6799H4.7697Z"
                      fill="#231F20" stroke="#231F20" stroke-width="0.46" stroke-miterlimit="10" />
                    <path
                      d="M8.57964 9.83015C6.11964 9.83015 4.12963 7.83015 4.11963 5.37015C4.11963 2.91015 6.11964 0.910156 8.57964 0.910156C11.0396 0.910156 13.0296 2.91015 13.0396 5.37015C13.0396 7.83015 11.0396 9.83015 8.57964 9.83015ZM8.57964 1.61015C6.49964 1.61015 4.80963 3.30016 4.80963 5.38016C4.80963 7.46016 6.49964 9.15015 8.57964 9.15015C10.6596 9.15015 12.3496 7.46016 12.3496 5.38016C12.3496 3.30016 10.6596 1.61015 8.57964 1.61015Z"
                      fill="#231F20" stroke="#231F20" stroke-width="0.46" stroke-miterlimit="10" />
                  </svg>
                  <span class="lispan"> {{ user ? user.username : 'User' }} ▸ </span></router-link>
                <!-- Nested Dropdown -->
                <ul class="nested-dropdown" v-show="isNestedDropdownOpen">
                  <li><router-link to="">{{ user.fullname }}</router-link></li>
                  <li class="bubbleli"><router-link to="">Bubble Help</router-link>




                    <!-- <input type="radio" :value="true" v-model="bubbles" @change="globalhelp(bubbles)" /> Yes
                    <input type="radio" :value="false" v-model="bubbles" @change="globalhelp(bubbles)" /> No -->


                    <label class="switch">
                      <input type="checkbox" v-model="bubbles" @change="globalhelp">
                      <span class="slider"></span>
                    </label>
                  </li>


                </ul>
              </li>
              <li @click="logout"><router-link to=""><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.57986 15.9902C3.41986 15.9902 0.109863 12.6902 0.109863 8.52019C0.109863 5.95019 1.32986 3.62018 3.53986 2.28018C3.90986 2.04018 4.26987 2.16019 4.51987 2.52019C4.76987 2.88019 4.63986 3.25018 4.27986 3.50018C2.56986 4.60018 1.58986 6.44019 1.58986 8.52019C1.58986 11.8202 4.27986 14.5202 7.58986 14.5202C10.8999 14.5202 13.5899 11.8302 13.5899 8.52019C13.5899 6.44019 12.6099 4.60018 10.8999 3.50018C10.5299 3.26018 10.4099 2.77019 10.6599 2.52019C10.8999 2.15019 11.3899 2.03018 11.6399 2.28018C13.7199 3.63018 15.0699 5.95019 15.0699 8.52019C15.0699 12.6802 11.7699 15.9902 7.59987 15.9902H7.57986Z"
                      fill="#231F20" />
                    <path
                      d="M7.58009 8.04092C7.21009 8.04092 6.8501 7.67093 6.8501 7.31093V1.19093C6.8501 0.820933 7.22009 0.460938 7.58009 0.460938C7.94009 0.460938 8.31009 0.830933 8.31009 1.19093V7.31093C8.31009 7.68093 7.94009 8.04092 7.58009 8.04092Z"
                      fill="#231F20" />
                  </svg>
                  <span class="lispan">

                    Logout
                  </span>
                </router-link></li>
            </ul>
          </div>
          <div class="mocktxt">
            <img src="/images/brain.png" alt="Brain"> Mock {{ mockIndex }}
            <span v-if="$route.name == 'MockReview'" style="text-transform: capitalize;">
              Review
            </span>

            <span v-if="$route.name == 'MockScore'" style="text-transform: capitalize;">
              Score
            </span>
          </div>
          <div class="mockquestion-navigate">
            <ul>
              <li v-if="$route.name == 'MockReview' && isRowFixed && fillicon == 1" class="mock-width"><svg width="16"
                  @click="$emit('SectionScroll')" height="18" viewBox="0 0 16 18" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.8199 9.23118L8.33997 2.74117C8.27997 2.69117 8.22002 2.65117 8.15002 2.62117C8.15002 2.62117 8.13 2.62117 8.12 2.62117C7.97 2.56117 7.81003 2.56117 7.66003 2.62117C7.59003 2.65117 7.52998 2.69117 7.47998 2.74117C7.47998 2.74117 7.46996 2.74117 7.45996 2.75117L0.969971 9.24117C0.849971 9.36117 0.790039 9.51117 0.790039 9.68117C0.790039 9.85117 0.849971 10.0012 0.969971 10.1212C1.08997 10.2412 1.24003 10.3012 1.41003 10.3012C1.58003 10.3012 1.72998 10.2312 1.84998 10.1212L7.29004 4.68117V16.7012C7.29004 17.0412 7.57003 17.3212 7.91003 17.3212C8.25003 17.3212 8.53003 17.0412 8.53003 16.7012V4.68117L13.96 10.1112C14.2 10.3512 14.59 10.3512 14.84 10.1112C15.09 9.87117 15.08 9.48118 14.84 9.23118H14.8199Z"
                    fill="#D1D3D4" />
                  <path
                    d="M1.41003 1.88063H14.39C14.73 1.88063 15.01 1.60062 15.01 1.26062C15.01 0.920624 14.73 0.640625 14.39 0.640625H1.41003C1.07003 0.640625 0.790039 0.920624 0.790039 1.26062C0.790039 1.60062 1.07003 1.88063 1.41003 1.88063Z"
                    fill="#D1D3D4" />
                </svg>
                <span v-if="bubbles == 1" style="width:80px; padding: 3px 3px;">Top of page</span>
              </li>

              <li v-if="$route.name == 'MockReview'" :class="{ 'mock-widths': $route.name === 'MockReview' }"
                style="cursor: default;">
                <CircularProgress :percentage="roundedPercent ? roundedPercent : 0" :fontSize="16" :width="100"
                  :color="'white'" :height="5" :Gap="8" :Containerheight="7" />


              </li>
              <li :class="{ 'mock-width': $route.name === 'MockReview' }" class="fontsizing"
                v-if="$route.name !== 'MockScore'"><router-link to="">
                  <span v-if="bubbles == 1" style="width:80px; padding: 3px 3px;">Bird's eye view</span>

                  <svg @click="notifyParent()" v-if="fillicon == 1" width="18" height="18" viewBox="0 0 18 18"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.32001 17.6184H1.82001C0.930007 17.6184 0.210022 16.8984 0.210022 16.0084V11.5084C0.210022 10.6184 0.930007 9.89844 1.82001 9.89844H6.32001C7.21001 9.89844 7.92999 10.6184 7.92999 11.5084V16.0084C7.92999 16.8984 7.21001 17.6184 6.32001 17.6184ZM1.82001 10.5284C1.28001 10.5284 0.830017 10.9684 0.830017 11.5184V16.0184C0.830017 16.5584 1.27001 17.0084 1.82001 17.0084H6.32001C6.86001 17.0084 7.31 16.5684 7.31 16.0184V11.5184C7.31 10.9784 6.87001 10.5284 6.32001 10.5284H1.82001Z"
                      fill="#D1D3D4" />
                    <path
                      d="M15.42 17.6184H10.92C10.03 17.6184 9.31 16.8984 9.31 16.0084V11.5084C9.31 10.6184 10.03 9.89844 10.92 9.89844H15.42C16.31 9.89844 17.03 10.6184 17.03 11.5084V16.0084C17.03 16.8984 16.31 17.6184 15.42 17.6184ZM10.92 10.5284C10.38 10.5284 9.92999 10.9684 9.92999 11.5184V16.0184C9.92999 16.5584 10.37 17.0084 10.92 17.0084H15.42C15.96 17.0084 16.41 16.5684 16.41 16.0184V11.5184C16.41 10.9784 15.97 10.5284 15.42 10.5284H10.92Z"
                      fill="#D1D3D4" />
                    <path
                      d="M6.32001 8.58914H1.82001C0.930007 8.58914 0.210022 7.86914 0.210022 6.97914V2.47914C0.210022 1.58914 0.930007 0.869141 1.82001 0.869141H6.32001C7.21001 0.869141 7.92999 1.58914 7.92999 2.47914V6.97914C7.92999 7.86914 7.21001 8.58914 6.32001 8.58914ZM1.82001 1.49914C1.28001 1.49914 0.830017 1.93914 0.830017 2.48914V6.98914C0.830017 7.52914 1.27001 7.97914 1.82001 7.97914H6.32001C6.86001 7.97914 7.31 7.53914 7.31 6.98914V2.48914C7.31 1.94914 6.87001 1.49914 6.32001 1.49914H1.82001Z"
                      fill="#D1D3D4" />
                    <path
                      d="M15.42 8.58914H10.92C10.03 8.58914 9.31 7.86914 9.31 6.97914V2.47914C9.31 1.58914 10.03 0.869141 10.92 0.869141H15.42C16.31 0.869141 17.03 1.58914 17.03 2.47914V6.97914C17.03 7.86914 16.31 8.58914 15.42 8.58914ZM11.2 1.89914C10.72 1.89914 10.34 2.28914 10.34 2.75914V6.68914C10.34 7.16914 10.73 7.54914 11.2 7.54914H15.13C15.6 7.54914 15.99 7.15914 15.99 6.68914V2.75914C15.99 2.27914 15.6 1.89914 15.13 1.89914H11.2Z"
                      fill="#D1D3D4" />
                    <path
                      d="M6.40002 8.58914H1.90002C1.01002 8.58914 0.289978 7.86914 0.289978 6.97914V2.47914C0.289978 1.58914 1.01002 0.869141 1.90002 0.869141H6.40002C7.29002 0.869141 8.01001 1.58914 8.01001 2.47914V6.97914C8.01001 7.86914 7.29002 8.58914 6.40002 8.58914ZM2.17999 1.89914C1.69999 1.89914 1.32001 2.28914 1.32001 2.75914V6.68914C1.32001 7.16914 1.70999 7.54914 2.17999 7.54914H6.10999C6.57999 7.54914 6.96997 7.15914 6.96997 6.68914V2.75914C6.96997 2.27914 6.57999 1.89914 6.10999 1.89914H2.17999Z"
                      fill="#D1D3D4" />
                    <path
                      d="M15.42 17.4993H10.92C10.03 17.4993 9.31 16.7793 9.31 15.8893V11.3893C9.31 10.4993 10.03 9.7793 10.92 9.7793H15.42C16.31 9.7793 17.03 10.4993 17.03 11.3893V15.8893C17.03 16.7793 16.31 17.4993 15.42 17.4993ZM11.2 10.8093C10.72 10.8093 10.34 11.1993 10.34 11.6693V15.5993C10.34 16.0793 10.73 16.4593 11.2 16.4593H15.13C15.6 16.4593 15.99 16.0693 15.99 15.5993V11.6693C15.99 11.1893 15.6 10.8093 15.13 10.8093H11.2Z"
                      fill="#D1D3D4" />
                    <path
                      d="M6.40002 17.4993H1.90002C1.01002 17.4993 0.289978 16.7793 0.289978 15.8893V11.3893C0.289978 10.4993 1.01002 9.7793 1.90002 9.7793H6.40002C7.29002 9.7793 8.01001 10.4993 8.01001 11.3893V15.8893C8.01001 16.7793 7.29002 17.4993 6.40002 17.4993ZM2.17999 10.8093C1.69999 10.8093 1.32001 11.1993 1.32001 11.6693V15.5993C1.32001 16.0793 1.70999 16.4593 2.17999 16.4593H6.10999C6.57999 16.4593 6.96997 16.0693 6.96997 15.5993V11.6693C6.96997 11.1893 6.57999 10.8093 6.10999 10.8093H2.17999Z"
                      fill="#D1D3D4" />
                  </svg>

                  <svg v-else-if="filleye || fillicon == 0" @click="notifyParentQuestion()" width="17" height="18"
                    viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.2301 17.3177H1.7301C0.840103 17.3177 0.120117 16.5977 0.120117 15.7077V11.2077C0.120117 10.3177 0.840103 9.59766 1.7301 9.59766H6.2301C7.1201 9.59766 7.84009 10.3177 7.84009 11.2077V15.7077C7.84009 16.5977 7.1201 17.3177 6.2301 17.3177Z"
                      fill="#D1D3D4" />
                    <path
                      d="M15.34 17.3177H10.84C9.94997 17.3177 9.22998 16.5977 9.22998 15.7077V11.2077C9.22998 10.3177 9.94997 9.59766 10.84 9.59766H15.34C16.23 9.59766 16.95 10.3177 16.95 11.2077V15.7077C16.95 16.5977 16.23 17.3177 15.34 17.3177Z"
                      fill="#D1D3D4" />
                    <path
                      d="M6.2301 8.27859H1.7301C0.840103 8.27859 0.120117 7.55859 0.120117 6.66859V2.16859C0.120117 1.27859 0.840103 0.558594 1.7301 0.558594H6.2301C7.1201 0.558594 7.84009 1.27859 7.84009 2.16859V6.66859C7.84009 7.55859 7.1201 8.27859 6.2301 8.27859Z"
                      fill="#D1D3D4" />
                    <path
                      d="M15.34 8.27859H10.84C9.94997 8.27859 9.22998 7.55859 9.22998 6.66859V2.16859C9.22998 1.27859 9.94997 0.558594 10.84 0.558594H15.34C16.23 0.558594 16.95 1.27859 16.95 2.16859V6.66859C16.95 7.55859 16.23 8.27859 15.34 8.27859Z"
                      fill="#D1D3D4" />
                  </svg>



                  <!--                  
                  <svg  v-else-if="fillicon == 1" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.32001 17.6184H1.82001C0.930007 17.6184 0.210022 16.8984 0.210022 16.0084V11.5084C0.210022 10.6184 0.930007 9.89844 1.82001 9.89844H6.32001C7.21001 9.89844 7.92999 10.6184 7.92999 11.5084V16.0084C7.92999 16.8984 7.21001 17.6184 6.32001 17.6184ZM1.82001 10.5284C1.28001 10.5284 0.830017 10.9684 0.830017 11.5184V16.0184C0.830017 16.5584 1.27001 17.0084 1.82001 17.0084H6.32001C6.86001 17.0084 7.31 16.5684 7.31 16.0184V11.5184C7.31 10.9784 6.87001 10.5284 6.32001 10.5284H1.82001Z" fill="#D1D3D4"/>
                    <path d="M15.42 17.6184H10.92C10.03 17.6184 9.31 16.8984 9.31 16.0084V11.5084C9.31 10.6184 10.03 9.89844 10.92 9.89844H15.42C16.31 9.89844 17.03 10.6184 17.03 11.5084V16.0084C17.03 16.8984 16.31 17.6184 15.42 17.6184ZM10.92 10.5284C10.38 10.5284 9.92999 10.9684 9.92999 11.5184V16.0184C9.92999 16.5584 10.37 17.0084 10.92 17.0084H15.42C15.96 17.0084 16.41 16.5684 16.41 16.0184V11.5184C16.41 10.9784 15.97 10.5284 15.42 10.5284H10.92Z" fill="#D1D3D4"/>
                    <path d="M6.32001 8.58914H1.82001C0.930007 8.58914 0.210022 7.86914 0.210022 6.97914V2.47914C0.210022 1.58914 0.930007 0.869141 1.82001 0.869141H6.32001C7.21001 0.869141 7.92999 1.58914 7.92999 2.47914V6.97914C7.92999 7.86914 7.21001 8.58914 6.32001 8.58914ZM1.82001 1.49914C1.28001 1.49914 0.830017 1.93914 0.830017 2.48914V6.98914C0.830017 7.52914 1.27001 7.97914 1.82001 7.97914H6.32001C6.86001 7.97914 7.31 7.53914 7.31 6.98914V2.48914C7.31 1.94914 6.87001 1.49914 6.32001 1.49914H1.82001Z" fill="#D1D3D4"/>
                    <path d="M15.42 8.58914H10.92C10.03 8.58914 9.31 7.86914 9.31 6.97914V2.47914C9.31 1.58914 10.03 0.869141 10.92 0.869141H15.42C16.31 0.869141 17.03 1.58914 17.03 2.47914V6.97914C17.03 7.86914 16.31 8.58914 15.42 8.58914ZM11.2 1.89914C10.72 1.89914 10.34 2.28914 10.34 2.75914V6.68914C10.34 7.16914 10.73 7.54914 11.2 7.54914H15.13C15.6 7.54914 15.99 7.15914 15.99 6.68914V2.75914C15.99 2.27914 15.6 1.89914 15.13 1.89914H11.2Z" fill="#D1D3D4"/>
                    <path d="M6.40002 8.58914H1.90002C1.01002 8.58914 0.289978 7.86914 0.289978 6.97914V2.47914C0.289978 1.58914 1.01002 0.869141 1.90002 0.869141H6.40002C7.29002 0.869141 8.01001 1.58914 8.01001 2.47914V6.97914C8.01001 7.86914 7.29002 8.58914 6.40002 8.58914ZM2.17999 1.89914C1.69999 1.89914 1.32001 2.28914 1.32001 2.75914V6.68914C1.32001 7.16914 1.70999 7.54914 2.17999 7.54914H6.10999C6.57999 7.54914 6.96997 7.15914 6.96997 6.68914V2.75914C6.96997 2.27914 6.57999 1.89914 6.10999 1.89914H2.17999Z" fill="#D1D3D4"/>
                    <path d="M15.42 17.4993H10.92C10.03 17.4993 9.31 16.7793 9.31 15.8893V11.3893C9.31 10.4993 10.03 9.7793 10.92 9.7793H15.42C16.31 9.7793 17.03 10.4993 17.03 11.3893V15.8893C17.03 16.7793 16.31 17.4993 15.42 17.4993ZM11.2 10.8093C10.72 10.8093 10.34 11.1993 10.34 11.6693V15.5993C10.34 16.0793 10.73 16.4593 11.2 16.4593H15.13C15.6 16.4593 15.99 16.0693 15.99 15.5993V11.6693C15.99 11.1893 15.6 10.8093 15.13 10.8093H11.2Z" fill="#D1D3D4"/>
                    <path d="M6.40002 17.4993H1.90002C1.01002 17.4993 0.289978 16.7793 0.289978 15.8893V11.3893C0.289978 10.4993 1.01002 9.7793 1.90002 9.7793H6.40002C7.29002 9.7793 8.01001 10.4993 8.01001 11.3893V15.8893C8.01001 16.7793 7.29002 17.4993 6.40002 17.4993ZM2.17999 10.8093C1.69999 10.8093 1.32001 11.1993 1.32001 11.6693V15.5993C1.32001 16.0793 1.70999 16.4593 2.17999 16.4593H6.10999C6.57999 16.4593 6.96997 16.0693 6.96997 15.5993V11.6693C6.96997 11.1893 6.57999 10.8093 6.10999 10.8093H2.17999Z" fill="#D1D3D4"/>
                    </svg> -->


                  <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.32001 17.6184H1.82001C0.930007 17.6184 0.210022 16.8984 0.210022 16.0084V11.5084C0.210022 10.6184 0.930007 9.89844 1.82001 9.89844H6.32001C7.21001 9.89844 7.92999 10.6184 7.92999 11.5084V16.0084C7.92999 16.8984 7.21001 17.6184 6.32001 17.6184ZM1.82001 10.5284C1.28001 10.5284 0.830017 10.9684 0.830017 11.5184V16.0184C0.830017 16.5584 1.27001 17.0084 1.82001 17.0084H6.32001C6.86001 17.0084 7.31 16.5684 7.31 16.0184V11.5184C7.31 10.9784 6.87001 10.5284 6.32001 10.5284H1.82001Z"
                      fill="#D1D3D4" />
                    <path
                      d="M15.42 17.6184H10.92C10.03 17.6184 9.31 16.8984 9.31 16.0084V11.5084C9.31 10.6184 10.03 9.89844 10.92 9.89844H15.42C16.31 9.89844 17.03 10.6184 17.03 11.5084V16.0084C17.03 16.8984 16.31 17.6184 15.42 17.6184ZM10.92 10.5284C10.38 10.5284 9.92999 10.9684 9.92999 11.5184V16.0184C9.92999 16.5584 10.37 17.0084 10.92 17.0084H15.42C15.96 17.0084 16.41 16.5684 16.41 16.0184V11.5184C16.41 10.9784 15.97 10.5284 15.42 10.5284H10.92Z"
                      fill="#D1D3D4" />
                    <path
                      d="M6.32001 8.58914H1.82001C0.930007 8.58914 0.210022 7.86914 0.210022 6.97914V2.47914C0.210022 1.58914 0.930007 0.869141 1.82001 0.869141H6.32001C7.21001 0.869141 7.92999 1.58914 7.92999 2.47914V6.97914C7.92999 7.86914 7.21001 8.58914 6.32001 8.58914ZM1.82001 1.49914C1.28001 1.49914 0.830017 1.93914 0.830017 2.48914V6.98914C0.830017 7.52914 1.27001 7.97914 1.82001 7.97914H6.32001C6.86001 7.97914 7.31 7.53914 7.31 6.98914V2.48914C7.31 1.94914 6.87001 1.49914 6.32001 1.49914H1.82001Z"
                      fill="#D1D3D4" />
                    <path
                      d="M15.42 8.58914H10.92C10.03 8.58914 9.31 7.86914 9.31 6.97914V2.47914C9.31 1.58914 10.03 0.869141 10.92 0.869141H15.42C16.31 0.869141 17.03 1.58914 17.03 2.47914V6.97914C17.03 7.86914 16.31 8.58914 15.42 8.58914ZM11.2 1.89914C10.72 1.89914 10.34 2.28914 10.34 2.75914V6.68914C10.34 7.16914 10.73 7.54914 11.2 7.54914H15.13C15.6 7.54914 15.99 7.15914 15.99 6.68914V2.75914C15.99 2.27914 15.6 1.89914 15.13 1.89914H11.2Z"
                      fill="#D1D3D4" />
                    <path
                      d="M6.40002 8.58914H1.90002C1.01002 8.58914 0.289978 7.86914 0.289978 6.97914V2.47914C0.289978 1.58914 1.01002 0.869141 1.90002 0.869141H6.40002C7.29002 0.869141 8.01001 1.58914 8.01001 2.47914V6.97914C8.01001 7.86914 7.29002 8.58914 6.40002 8.58914ZM2.17999 1.89914C1.69999 1.89914 1.32001 2.28914 1.32001 2.75914V6.68914C1.32001 7.16914 1.70999 7.54914 2.17999 7.54914H6.10999C6.57999 7.54914 6.96997 7.15914 6.96997 6.68914V2.75914C6.96997 2.27914 6.57999 1.89914 6.10999 1.89914H2.17999Z"
                      fill="#D1D3D4" />
                    <path
                      d="M15.42 17.4993H10.92C10.03 17.4993 9.31 16.7793 9.31 15.8893V11.3893C9.31 10.4993 10.03 9.7793 10.92 9.7793H15.42C16.31 9.7793 17.03 10.4993 17.03 11.3893V15.8893C17.03 16.7793 16.31 17.4993 15.42 17.4993ZM11.2 10.8093C10.72 10.8093 10.34 11.1993 10.34 11.6693V15.5993C10.34 16.0793 10.73 16.4593 11.2 16.4593H15.13C15.6 16.4593 15.99 16.0693 15.99 15.5993V11.6693C15.99 11.1893 15.6 10.8093 15.13 10.8093H11.2Z"
                      fill="#D1D3D4" />
                    <path
                      d="M6.40002 17.4993H1.90002C1.01002 17.4993 0.289978 16.7793 0.289978 15.8893V11.3893C0.289978 10.4993 1.01002 9.7793 1.90002 9.7793H6.40002C7.29002 9.7793 8.01001 10.4993 8.01001 11.3893V15.8893C8.01001 16.7793 7.29002 17.4993 6.40002 17.4993ZM2.17999 10.8093C1.69999 10.8093 1.32001 11.1993 1.32001 11.6693V15.5993C1.32001 16.0793 1.70999 16.4593 2.17999 16.4593H6.10999C6.57999 16.4593 6.96997 16.0693 6.96997 15.5993V11.6693C6.96997 11.1893 6.57999 10.8093 6.10999 10.8093H2.17999Z"
                      fill="#D1D3D4" />
                  </svg>

                </router-link>
              </li>
              <li :class="{ 'mock-width': $route.name === 'MockReview' }" style="cursor: default;"
                v-if="$route.name !== 'MockScore'"><span class="flaggedquestions" v-if="bubbles == 1">Flagged
                  questions</span><svg width="14.52" height="17" viewBox="0 0 19 17" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.08997 1.53079C6.14997 -0.149209 3.05998 -0.309209 0.0999756 1.03079V14.5608C2.83998 13.1308 5.71005 13.1708 8.43005 14.7308C10.0601 15.6608 11.7401 16.1308 13.4301 16.1308C15.1201 16.1308 16.7901 15.6608 18.4301 14.7308L18.77 14.5408V0.960784L17.77 1.53079C14.93 3.15079 11.94 3.15079 9.09998 1.53079H9.08997Z"
                    fill="#D1D3D4" />
                </svg>
                <p>
                  {{ flagcounts }}
                </p>
              </li>

              <li style="position:relative" v-if="$route.name !== 'MockReview' && $route.name !== 'MockScore'">
             



                <!-- <svg v-show="showclock" @click="showclock = false" width="27" height="27" viewBox="0 0 120 160">
                 
                  <rect x="40" y="10" width="40" height="20" rx="2" fill="#D1D3D4" />

                
                  <line x1="60" y1="30" x2="60" y2="68" stroke="#D1D3D4" stroke-width="10" />

                
                  <circle cx="60" cy="100" r="52" :fill="remainingTimeInSeconds <= 600 ? 'yellow' : 'white'"
                    stroke="#D1D3D4" stroke-width="10" />

                
                  <path id="fillPath" fill="black">
                    <animate  ref="clockAnimation" attributeName="d" dur="10s" repeatCount="1" fill="freeze" values="
                        M60,100 L60,48 A52,52 0 0,1 60,48 Z;
                        M60,100 L60,48 A52,52 0 0,1 107.94,68 Z;
                        M60,100 L60,48 A52,52 0 0,1 108,132 Z;
                        M60,100 L60,48 A52,52 0 0,1 60,152 Z;
                        M60,100 L60,48 A52,52 0 0,1 12,132 Z;
                        M60,100 L60,48 A52,52 0 0,1 12,68 Z;
                        M60,100 L60,48 A52,52 0 1,1 60,48 Z
                      " />
                  </path>
                </svg> -->

                <svg v-show="showclock" @click="showclock = false" width="27" height="27" viewBox="0 0 120 160">
                  <!-- Top button -->
                  <rect x="40" y="10" width="40" height="20" rx="2" fill="#D1D3D4" />
                  <line x1="60" y1="30" x2="60" y2="68" stroke="#D1D3D4" stroke-width="10" />
                  <circle cx="60" cy="100" r="52"
                    :fill="remainingTimeInSeconds <= 600 ? 'yellow' : 'white'"
                    stroke="#D1D3D4" stroke-width="10" />
            
                  <!-- Dynamic path instead of <animate> -->
                  <path :d="arcPath" fill="black" />
                </svg>
                
                







                <span v-if="bubbles == 1">Time remaining</span>
                <p v-if="!showclock" @click="handleShowClock" class="timer"
                  :style="{ color: remainingTimeInSeconds <= 600 ? 'yellow' : 'white' }">{{ formattedTime }}</p>


              </li>

              <li v-if="$route.name == 'MockReview' || $route.name == 'MockScore'" style="cursor: default;"
                :class="{ 'mock-width': $route.name === 'MockReview' || $route.name == 'MockScore' }">

                <div class="roundcount" style="background: linear-gradient(to right, #A6EE85 50%, #FFBABE 50%);">
                  <!-- {{ Math.abs(unanswered) ?? 0 }}  -->

                  {{ (correctcount ?? 0) + (incorrectcount ?? 0) }}


                </div>
              </li>

              <li v-if="$route.name == 'MockReview' || $route.name == 'MockScore'" style="cursor: default;"
                :class="{ 'mock-width': $route.name === 'MockReview' || $route.name == 'MockScore' }">



                <div class="roundcount" style="background-color:#A6EE85">
                  {{ correctcount ?? 0 }}


                </div>


              </li>




              <li v-if="$route.name == 'MockReview' || $route.name == 'MockScore'" style="cursor: default;"
                :class="{ 'mock-width': $route.name === 'MockReview' || $route.name == 'MockScore' }">

                <div class="roundcount" style="background-color:#FFBABE">
                  {{ incorrectcount ?? 0 }}


                </div>


              </li>

              <li v-if="$route.name !== 'MockReview' && $route.name !== 'MockScore'" class="pause"><span
                  class="pausemock" v-if="bubbles == 1">Pause
                  mock</span>

                <svg v-if="showPauseModal" @click="Resuming" width="25" height="25" viewBox="0 0 25 25" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <!-- Outer Circle -->
                  <circle cx="12.5" cy="12.5" r="12" stroke="#D1D3D4" stroke-width="1" fill="none" />
                  <!-- Play Triangle -->
                  <path d="M10 8L17 12.5L10 17V8Z" fill="#D1D3D4" />
                </svg>

                <svg @click="PauseModal" v-else width="25" height="25" viewBox="0 0 25 25" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.9699 0.359375C13.2399 0.429375 13.5399 0.419373 13.8199 0.45973C24.4099 1.91937 27.81 15.7194 19.06 21.9394C11.8 27.0994 1.58998 22.6594 0.389978 13.8894C0.349978 13.6094 0.360002 13.3094 0.290002 13.0394C0.310002 12.5194 0.260002 11.9794 0.290002 11.4594C0.630002 5.61937 5.54997 0.699375 11.38 0.359375H12.9599H12.9699ZM11.6099 2.27937C3.50995 2.75937 -0.740047 12.3094 4.48995 18.6094C8.86995 23.8894 17.11 23.2794 20.68 17.4394C24.87 10.5994 19.5599 1.79937 11.5999 2.26937L11.6099 2.27937Z"
                    fill="#D1D3D4" />
                  <path
                    d="M14.49 6.44939C15.37 6.29939 15.8799 6.94939 15.9399 7.75939C16.1499 10.5994 15.7799 13.7094 15.9399 16.5794C15.7999 18.2894 13.66 18.2194 13.53 16.6794V7.57939C13.56 7.06939 13.98 6.53939 14.49 6.44939Z"
                    fill="#D1D3D4" />
                  <path
                    d="M10.8199 6.77901C10.9999 6.95901 11.14 7.26901 11.16 7.52901V16.819C10.9 18.169 9.08004 18.199 8.79004 16.859V7.48901C8.88004 6.50901 10.1201 6.08901 10.8101 6.78901L10.8199 6.77901Z"
                    fill="#D1D3D4" />
                </svg>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <transition name="fade">
      <PauseMockModal v-if="showPauseModal || stoptimerpopup" @close="Resuming" @resume="Resuming"
        @exit="handleExitMock" />
    </transition>
  </div>
</template>


<script>


import PauseMockModal from './PauseMockModal.vue';
import { mapGetters } from "vuex";
import { get } from "../views/lib/api";
import CircularProgress from './CircularProgress.vue';


export default {
  components: {
    CircularProgress,
    PauseMockModal
  },

  props: {
    flagcounts: {

    },
    remainingTimeInSeconds: {

    },
    formattedTime: {

    },
    stoptimerpopup: {},
    fillicon: {},
    isRowFixed: {},
    correctcount: {},
    incorrectcount: {},
    unanswered: {},
    roundedPercent: {},
    hideMockHome: {
      type: Boolean,
      default: false
    }




  },
  data() {
    return {
      isMainDropdownOpen: false,
      isNestedDropdownOpen: false,
      showPauseModal: false,
      scrollPosition: 0,
      showclock: false,
      filleye: false,
      mockIndex: 0,
      coloring: '#fff',
      bubbles: null, 
      
      totalDuration: 10800 * 1000, 
      startTime: Date.now(),
      currentTime: 0,
      interval: null,



    }
  },

  created() {

    this.coloring = this.remainingTimeInSeconds <= 600 ? 'yellow' : 'white'

    this.mockIndex = parseInt(localStorage.getItem('mockindex'), 10);


    get("/getglobalhelp").then((res) => {
      console.log('data', res.data.data)

      this.bubbles = res.data.data.value == 0 ? false : true

    });

  },

  computed: {
    ...mapGetters(["user"]), // your getter is named "user"

    remainingTimeInSecondss() {
      return Math.floor((this.totalDuration - this.currentTime) / 1000);
    },
    arcPath() {
      const progress = Math.min(this.currentTime / this.totalDuration, 1);
      const radius = 52;
      const cx = 60;
      const cy = 100;
      const startAngle = -Math.PI / 2; // 12 o'clock
      const endAngle = startAngle + progress * 2 * Math.PI;

      const x1 = cx + radius * Math.cos(startAngle);
      const y1 = cy + radius * Math.sin(startAngle);
      const x2 = cx + radius * Math.cos(endAngle);
      const y2 = cy + radius * Math.sin(endAngle);
      const largeArcFlag = progress > 0.5 ? 1 : 0;

      return `M${cx},${cy} L${x1},${y1} A${radius},${radius} 0 ${largeArcFlag},1 ${x2},${y2} Z`;
    },
  },

  mounted() {
    this.startTimer();
    this._outsideClickHandler = (e) => {
      const el = this.$el.querySelector('.mockhead-hamburger');
      if (el && !el.contains(e.target)) {
        this.isMainDropdownOpen = false;
        this.isNestedDropdownOpen = false;
      }
    };
    document.addEventListener('click', this._outsideClickHandler);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    document.removeEventListener('click', this._outsideClickHandler);
    if (this.showPauseModal) {
      this.unlockBodyScroll();
    }
  },
  methods: {

    startTimer() {
      this.interval = setInterval(() => {
        this.currentTime = Date.now() - this.startTime;
        if (this.currentTime >= this.totalDuration) {
          clearInterval(this.interval);
          this.currentTime = this.totalDuration;
        }
      }, 100); // 10 fps update
    },

    handleShowClock() {
      this.showclock = true;

     
      this.$nextTick(() => {
        const anim = this.$refs.clockAnimation;
        if (anim) {
          anim.beginElement(); 
        }
      });
    },


    globalhelp() {

      console.log('eee', this.bubbles)

      get("/globalhelp?value=" + this.bubbles).then((res) => {
        console.log('data', res.data.data)
        this.$emit('globalhelp')

        this.bubbles = res.data.data.value == 0 ? false : true

      });

    },

    logout() {
      localStorage.removeItem("token");
      this.$store.dispatch("user", null);
      this.$router.push("/");
    },

    PauseModal() {
      this.showPauseModal = true
      this.$emit('showstoptimer')

    },

    Resuming() {
      this.showPauseModal = false
      this.$emit('startagain')
    },

    notifyParent() {
      if (this.showPauseModal) {
        return
      }
      console.log('hello')
      this.filleye = true

      this.$emit('birdseye');
    },


    notifyParentQuestion() {
      if (this.showPauseModal) {
        return
      }
      console.log('hellossss')
      this.filleye = false

      this.$emit('returnquestion');
    },




    toggleMainDropdown() {
      this.isMainDropdownOpen = !this.isMainDropdownOpen;
    },
    toggleNestedDropdown() {
      this.isNestedDropdownOpen = !this.isNestedDropdownOpen;
    },
    handleExitMock() {
      this.showPauseModal = false;
      this.$emit('exitmock')

      // this.$router.push('/mocksection'); 
    },
    lockBodyScroll() {
      this.scrollPosition = window.pageYOffset;
      document.body.classList.add('body-scroll-lock');
      document.body.style.top = `-${this.scrollPosition}px`;
    },

    unlockBodyScroll() {
      document.body.classList.remove('body-scroll-lock');
      window.scrollTo(0, this.scrollPosition);
      document.body.style.top = '';
    },
  },

 
  watch: {
    showPauseModal(newVal) {
      if (newVal) {
        this.lockBodyScroll();
      } else {
        this.unlockBodyScroll();
      }
    }
  },
}

</script>



<style scoped>
span.lispan {
  padding-top: 3px;
}


/* From Uiverse.io by arghyaBiswasDev */
/* The switch - the box around the slider */
.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 35px;
  height: 18px;
  transition: all .6s ease;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
  transition: all .6s ease;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border: 1px solid #adb5bd;
  transition: .8s;
  border-radius: 30px;
  transition: all .6s ease;
}

.slider::before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  border-radius: 20px;
  left: 0.18em;
  bottom: 2px;
  background-color: #adb5bd;
  transition: all .6s ease;
}


input:checked+.slider {
  background-color: #20b14b;
  border: 1px solid #20b14b;
  transition: all .6s ease;
}

input:focus+.slider {
  box-shadow: 0 0 1px #20b14b;
  transition: all .6s ease;
}

input:checked+.slider:before {
  transform: translateX(14px);
  background-color: #fff;
  transition: all .6s ease;
}


li.bubbleli {
  display: flex;
  justify-content: space-between;
}

p {
  padding-top: 0px;
}

p.timer {
  padding: 0px 9px;

  font-size: 15px;
}

.mock-width {
  width: 17% !important;
}

.mock-widths {
  width: 100% !important;
}

svg.circle_svg {
  position: absolute;

  top: 1px;
  right: 12px;

}


.header-icon-wrapper {
  display: flex;
  align-items: center;
  padding: 5px 0px 0px 0px;
}

.hamburger-icon {
  height: 100%;
  position: relative;
}

.hamburger-icon svg {
  width: 24px;
  height: 24px;
  color: #fff;
  cursor: pointer;
}

.hamburger-icon span {
  position: absolute;
  width: auto;
  top: -22px;
  font-size: 11px;
  background-color: #9DED6C;
  padding: 3px 6px;
  border-radius: 6px;
  color: #000000;
  left: 10px;
  visibility: hidden;
  opacity: 0;
}


.hamburger-icon span::before {
  position: absolute;
  content: "";
  background: #9DED6C;
  width: 10px;
  height: 10px;
  bottom: -9px;
  clip-path: polygon(0 0, 0% 100%, 100% 0);
}

.hamburger-icon:hover span {
  visibility: visible;
  opacity: 1;
}

.mockhead-hamburger {
  position: relative;
  display: inline-block;
}

.main-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  min-width: 200px;
  box-shadow: 0 0px 9px 1px #00000080;
  padding: 10px 0;
  z-index: 1000;
  border-radius: 20px;
  border: 0.31px solid #8698A2;
}

/* Hover Effects */
.mockhead-hamburger:hover .main-dropdown {
  display: block;
}

.has-nested {
  position: relative;
}

.nested-dropdown {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  background: #f8f8f8;
  min-width: 160px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.has-nested:hover .nested-dropdown {
  display: block;
}

/* Link Styling */
/* .main-dropdown li {
  padding: 8px 15px;
  position: relative;
  font-family: Helvetica;
} */


.main-dropdown li {
  padding: 8px 15px;
  position: relative;
  font-family: Helvetica, Arial, sans-serif;
  line-height: 1.2;
  box-sizing: border-box;
}

ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.main-dropdown li a {
  color: #000;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  font-family: Helvetica;
}

.main-dropdown li a:hover {
  color: #ed1c24;
}

.nested-dropdown li {
  padding: 8px 15px;
  white-space: nowrap;
  color: #000;
  list-style: none;
  cursor: pointer;
}


.count-header-gradiant {
  display: flex !important;
  align-items: center !important;
  gap: 24px;
}

.round-count-colorchange {
  background: #A6EE85;
  color: #000;
}

.round-count-colorpink {
  background: #FFBABE;
  color: #000;
}


.slide-modal-enter-active {
  animation: slide-in 0.3s ease-out;
}

.slide-modal-leave-active {
  animation: slide-out 0.3s ease-in;
}

@keyframes slide-in {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(-100%);
    opacity: 0;
  }
}


@media only screen and (min-height: 1024px) {


  .mockquestion-navigate ul li p {
    padding-top: 2px;
  }

  p {
    padding-top: 3px;
  }


  p.timer {
    padding-top: 3px;
  }

}
</style>